/**
 * Shared segmented-button styling for the review's filter rows (Division,
 * Location): `index > 0` draws the divider between buttons, `isActive` fills
 * the button, `isDisabled` greys it out (nothing to select there).
 */
export function segmentedButtonClass(
  index: number,
  isActive: boolean,
  isDisabled = false,
): string {
  const divider = index > 0 ? ' border-l' : '';
  if (isDisabled) {
    return `px-3 py-1 transition-colors${divider} bg-muted text-muted-foreground/50 cursor-not-allowed`;
  }
  return `px-3 py-1 transition-colors${divider}${isActive ? ' bg-primary text-primary-foreground' : ' bg-background text-foreground hover:bg-muted'}`;
}
